module.exports = __webpack_public_path__ + "static/media/afternoon-passed-icon.04b1e68d.png";